import MatchingLoad1 from 'components/elements/icons/MatchingLoad1'
import InformationContent from 'components/elements/items/InformationContent'
import RequestedTemplate from 'components/templates/RequestedTemplate'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'

type MessageProps = {
  message: string
  large?: boolean
  small?: boolean
}

type InformationIconProps = {
  icon: React.ReactNode
  marginBottom?: string
}

/** 画面のステータス（1:トースト表示、2:トースト削除後、3:アニメーション表示） */
export const SCREEN_STATE = {
  VISBLE_TOAST: 1,
  INVISIBLE_TOAST: 2,
  SHOW_ANIMATION: 3,
}

/** 完了画面に表示するコンテンツ  */
const contentItems: Array<MessageProps | InformationIconProps> = [
  {
    message: 'ご要請を受け付けました。',
    large: true,
  },
  {
    message:
      '対応業者が決まりましたらSMSもしくは対応スタッフから連絡いたします。※追加でご案内・ご確認することがある場合はオペレーターからご連絡いたします。',
    small: true,
  },
  {
    icon: <MatchingLoad1 />,
    marginBottom: '15px',
  },
  {
    message: 'スタッフ到着まで安全な場所で画面を閉じてお待ちください。',
    small: true,
  },
]

/**
 * QN-08: 完了画面
 */
const Informed: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state } = props
  // 画面のステータス
  const [screenState, setScreenState] = React.useState(
    SCREEN_STATE.VISBLE_TOAST
  )

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (screenState === SCREEN_STATE.INVISIBLE_TOAST) {
        setScreenState(SCREEN_STATE.SHOW_ANIMATION)
      }
    }, 5000)
    return (): void => {
      clearTimeout(timeout)
    }
  }, [screenState])

  return (
    <RequestedTemplate
      title={'完了画面'}
      content={
        <InformationContent
          items={contentItems}
          contentHeight="400px"
          screenState={screenState}
          setScreenState={setScreenState}
        />
      }
      state={state}
    />
  )
}

export default Informed
